import {Component, OnDestroy, OnInit} from '@angular/core';
import {SharedService} from '../../../../services/shared.service';
import {CustomerService} from '../../../../services/customer.service';
import {PaymentDialogComponent} from '../../../../components/payment-dialog/payment-dialog.component';
import {MatDialog, MatDialogConfig} from '@angular/material';
import * as _ from 'lodash';
import {Subject} from 'rxjs';
import {takeUntil, first} from 'rxjs/operators';
import {OrderService} from '../../../../services/order.service';
import {Router} from '@angular/router';
import {CardModel} from '../../../../models/card.model';
import {PasswordDialogComponent} from '../../../../components/password-dialog/password-dialog.component';
import {OrderModel} from '../../../../models/order.model';
import {MatSnackBar} from '@angular/material';
import {SNACK_CONFIG} from '../../../../global';

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.scss']
})
export class PaymentComponent implements OnInit, OnDestroy {
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  private updates: any;
  selectedCard: CardModel;
  isGiveaway: boolean = false;
  order: any;
  selectedHours: Array<string> = [];
  address: string;
  showLoader: boolean = true;
  cards: Array<any> = ['american_express', 'discover', 'mastercard', 'visa'];
  isLoggedIn: boolean;
  rescheduleOrder: OrderModel;
  discounts: Array<any> = [];
  totalDiscount: number = 0;
  promoCodeClaim: string;

  constructor(private shared: SharedService,
              private customerService: CustomerService,
              private dialog: MatDialog,
              private router: Router,
              private snack: MatSnackBar,
              private orderService: OrderService) {
    this.shared.sendEvent({type: 'request_step', data: {step: 5, name: 'REQUEST.PAYMENT.NAME'}});
    if (this.shared.getStep() != 'payment') this.router.navigate(['account', 'request', 'fuel']);
    this.rescheduleOrder = this.shared.getRescheduleOrder();
  }

  ngOnInit() {
    this.order = _.clone(this.shared.getOrder());
    this.address = this.order.specs.location.streetNumber + ' ' +
      this.order.specs.location.route + ', ' +
      this.order.specs.location.city + ', ' +
      this.order.specs.location.state + ' ' +
      this.order.specs.location.postalCode;
    Object.getOwnPropertyNames(this.order.selectedHours)
      .map(key => {
        if (this.order.selectedHours[key]) this.selectedHours.push(key);
      });
    this.customerService.authChanged()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(customer => {
        this.isLoggedIn = !!customer;
        if (this.isLoggedIn) this.refreshStripeInfo();
        else this.showLoader = false;
      });
    if (!this.rescheduleOrder) { //If order is not reschedule get user promos
      this.customerService.getCustomerPromos()
        .pipe(first())
        .toPromise()
        .then(promos => {
          let applyPromo;
          _.forEach(promos, (promo) => {
            if (!applyPromo && promo.status) {
              applyPromo = {type: 'promo', value: 5};
              if (promo.type == 'firstTimeReferredBy') applyPromo.referredBy = promo.id;
              if (promo.type == 'referrals') applyPromo.referral = promo.id;
            }
          });
          if (applyPromo) this.addingDiscount(applyPromo);
        });
    } else { //If order is reschedule check promos on reschedule order
      let resDiscounts = this.rescheduleOrder.discounts || {};
      _.forEach(resDiscounts, (discount) => {
        this.addingDiscount(discount);
      });
    }
    if (this.discounts.length === 0){
      this.customerService.isGiveawayWinner().then(giveaway =>{
        if (giveaway === true){
          let discounts = this.order['discounts'] || {};
          let id = ((new Date().getTime()).toString(32) + Math.round(Math.random() * 100000).toString(36)).toUpperCase();
          let calculatedDiscount = {type: 'giveaway',value: 100};
          calculatedDiscount['discount'] = 100;      
          calculatedDiscount['amount'] = 100;     
          this.isGiveaway = true;
          discounts[id] = calculatedDiscount; 
          this.discounts.push(calculatedDiscount);
          this.totalDiscount += 100;
          this.order.total = this.order.total - 100;
          this.order['discounts'] = discounts;
        }
      })
    }
  }

  addingDiscount(discount: Discount) {
    let discounts = this.order['discounts'] || {};
    let id = ((new Date().getTime()).toString(32) + Math.round(Math.random() * 100000).toString(36)).toUpperCase();
    discounts[id] = discount;
    this.order['discounts'] = discounts;
    let calculatedDiscount = {type: discount.type};
    if (discount.type == 'promo') calculatedDiscount['discount'] = Math.round(this.order.total * discount.value) / 100;
    discount.amount = calculatedDiscount['discount'];
    this.totalDiscount += discount.amount;
    this.discounts.push(calculatedDiscount);
    this.order.total = this.order.total - calculatedDiscount['discount'];
  }

  confirmPayment() {
    this.shared.updateOrder(this.updates);
    let order = _.clone(this.shared.getOrder());
    order.total = _.round(this.order.total, 2).toString();
    if (this.order.discounts) order.discounts = this.order.discounts;
    this.orderService.placeOrder(order)
      .then(snapshot => {
        this.customerService.getCurrentCustomer()
          .then(customer => {
            let orders = customer.orders || [];
            if (orders.indexOf(snapshot.key) == -1) orders.push(snapshot.key);
            this.customerService.updateCustomerProfile({orders: orders});
          });
        if (this.rescheduleOrder) this.orderService.updateOrder(this.rescheduleOrder.id, {isReplacedBy: snapshot.key, status: 6});
        this.router.navigate(['account', 'orders', 'details', snapshot.key]);
      })
      .catch(err => {
        console.log(err);
        this.shared.openErrorDialog({title: 'Error', body: 'Unexpected error. Please try again later.'});
      });
  }

  refreshStripeInfo() {
    this.showLoader = true;
    //Wait until current user is ready
    this.customerService.getCurrentCustomer()
      .then(customer => {
        this.updates = {
          customerID: customer.uid
        };
        return this.customerService.getStripeAccountInfo();
      })
      .then(info => {
        if (info['sources']['data'].length) {
          info['sources']['data'].forEach(source => {
            if (source.object == 'card') source = new CardModel(source);
            if (source.object == 'source' && source.type == 'card') source = new CardModel(source.card, source.id);
            if (source['id'] == info['default_source']) {
              this.selectedCard = source;
              this.updates['retention'] = {
                source: {
                  id: source['id'],
                  customer: info.id
                }
              };
            }
          });
        }
        this.showLoader = false;
      })
      .catch(err => {
        console.log(err);
        this.showLoader = false;
        this.shared.openErrorDialog({title: 'Error', body: 'Payment processing error. Please try again'});
      });
  }

  openPaymentDialog() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = true;
    let dialog = this.dialog.open(PaymentDialogComponent, dialogConfig);
    dialog.afterClosed()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(() => {
        this.refreshStripeInfo();
      });
  }

  openConfirmDialog() {
    if (!this.shared.getPasswordPass()) {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.autoFocus = true;
      let dialog = this.dialog.open(PasswordDialogComponent, dialogConfig);
      dialog.afterClosed()
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(() => {
          if (this.shared.getPasswordPass()) this.confirmPayment();
        });
    } else {
      this.confirmPayment();
    }

  }

  signUp() {
    this.shared.updateOrder({}, 'signup');
    return this.router.navigate(['account', 'request', 'sign-up']);
  }

  claimPromo(code: string) {
    this.showLoader = true; // show loader in left box also
    this.customerService.getCurrentCustomer()
      .then(customer => {
        let data = {
          promoCode: code,
          phone: customer.phone,
          countryCode: '+1'
        };
        return this.customerService.claimPromo(data);
      })
      .then(__ => {
        this.showLoader = false;
        this.promoCodeClaim = null;
        this.snack.open('Promo code claimed', null, SNACK_CONFIG);
        this.customerService.getCustomerPromos()
        .pipe(first())
        .toPromise()
        .then(promos => {
          let applyPromo;
          _.forEach(promos, (promo) => {
            if (!applyPromo && promo.status) {
              applyPromo = {type: 'promo', value: 5};
              if (promo.type == 'firstTimeReferredBy') applyPromo.referredBy = promo.id;
              if (promo.type == 'referrals') applyPromo.referral = promo.id;
            }
          });
          if (applyPromo) this.addingDiscount(applyPromo);
        });
      })
      .catch(err => {
        this.showLoader = false;
        let error = err.error;
        let message = err.errorMessage || error.errorMessage || 'Unexpected error. Please try again';
        this.shared.openErrorDialog({title: 'Error', body: message});
      });
  }

  ngOnDestroy(): void {
    //Unsubscribe from all events
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

}

interface Discount {
  type: string;
  value: number;
  amount?: number;
  referredBy?: string;
}
